module.exports = __webpack_public_path__ + "img/preset2.94e91bbf.png";